import { createContext } from "@lit/context";
const renderContext = createContext(Symbol("RenderContext"));
export {
  renderContext
};
